export const toHoursAndMinutes = minutesOnly => {
  const hours = Math.floor(minutesOnly / 60)
  const minutes = minutesOnly % 60
  return {
    hours,
    minutes,
  }
}
